import { ModalProps, withModalConditionalRender } from '@billy/design-system'

import { InvoiceFormReceiver } from '../../../invoices/types/invoiceForm/invoiceFormReceiver'
import { XRechnungEInvoicingAddressForm } from '../../types/xRechnungEInvoicingAddressForm'
import { XRechnungEInvoicingAddressFormContextProvider } from './contexts/xRechnungEInvoicingAddressFormContext'
import { DownloadAsXRechnungModalComponent } from './elements/DownloadAsXRechnungModalComponent'

interface DownloadAsXRechnungModalProps extends ModalProps {
  customer?: InvoiceFormReceiver | null
  isSubmitting: boolean
  onSubmit: (formData: XRechnungEInvoicingAddressForm) => void
}

const DownloadAsXRechnung = ({ customer, isSubmitting, onSubmit, ...modalProps }: DownloadAsXRechnungModalProps) => {
  return (
    <XRechnungEInvoicingAddressFormContextProvider customer={customer} isSubmitting={isSubmitting} onSubmit={onSubmit}>
      <DownloadAsXRechnungModalComponent {...modalProps} />
    </XRechnungEInvoicingAddressFormContextProvider>
  )
}

export const DownloadAsXRechnungModal = withModalConditionalRender(DownloadAsXRechnung)
